import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { IPopupDeleteWarningProps } from 'components/molecules/popup/delete-warning/PopupDeleteWarning';
import { useClientMode } from 'hooks/useClientMode';
import { useFormSave } from 'hooks/useFormSave';
import { useIsUserBanned } from 'hooks/useIsUserBanned';
import { useStoreState } from 'providers/StoreStateContext';
import { useTranslation } from 'react-i18next';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import ConditionalWarningPopupButton from '../conditional-warning-popup-button/ConditionalWarningPopupButton';

interface IIndividualPageButtonsProps extends IPopupDeleteWarningProps {
  onClick: () => void;
  editDisabled?: boolean;
  editDisabledDescription?: string;
}

const IndividualPageButtons = ({
  onClick,
  editDisabled = false,
  editDisabledDescription,
  ...deleteWarningProps
}: IIndividualPageButtonsProps) => {
  const { t } = useTranslation();
  const clientMode = useClientMode();
  const { clearForms } = useStoreState();

  const { isBanned } = useIsUserBanned();

  const { isAnyFormSaved } = useFormSave();
  return (
    <div className="flex">
      {!isBanned && (
        <ConditionalWarningPopupButton
          title={t('popup.new-form-cancelation-title')}
          message={t('popup.new-form-cancelation-description')}
          confirmButtonVariant={BUTTON_VARIANT.background}
          showWarning={isAnyFormSaved}
          onConfirm={(a) => {
            clearForms();
            onClick();
          }}
          isClear
          onlyIcon
          disabled={editDisabled}
        >
          <Button.Icon icon={<PiPencilSimpleLine />} />
          <Button.Description
            description={
              editDisabled && editDisabledDescription ? editDisabledDescription : t('button.edit')
            }
          />
        </ConditionalWarningPopupButton>
      )}
      {!isBanned && <MagellanPopups.DeleteWarning {...deleteWarningProps} />}
    </div>
  );
};

export default IndividualPageButtons;
